import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { SendTransactionRequest } from '@tonconnect/sdk';

export interface TonConnectTransactionRequest {
  tonDepositId: string;
  request: SendTransactionRequest;
}

@Injectable({
  providedIn: 'root',
})
export class TonConnectService {
  #handleConnect = new Subject<void>();
  handleConnect$ = this.#handleConnect.asObservable();

  #handleDisconnect = new Subject<void>();
  handleDisconnect$ = this.#handleDisconnect.asObservable();

  #walletAddress = new BehaviorSubject<string | null>(null);
  walletAddress$ = this.#walletAddress.asObservable();

  #handleTransaction = new Subject<TonConnectTransactionRequest>();
  handleTransaction$ = this.#handleTransaction.asObservable();

  set walletAddress(address: string | null) {
    this.#walletAddress.next(address);
  }

  connectWallet(): void {
    this.#handleConnect.next();
  }

  disconnectWallet(): void {
    this.#handleDisconnect.next();
  }

  sendTransaction(request: TonConnectTransactionRequest): void {
    this.#handleTransaction.next(request);
  }
}
